import { render } from "./MiGrupo.vue?vue&type=template&id=5972302a&scoped=true"
import script from "./MiGrupo.vue?vue&type=script&lang=js"
export * from "./MiGrupo.vue?vue&type=script&lang=js"

import "./MiGrupo.vue?vue&type=style&index=0&id=5972302a&scoped=true&lang=css"

import exportComponent from "/home/sensores-test/frontendv2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5972302a"]])

export default __exports__